import React from 'react';

import { View } from '@24i/nxg-sdk-quarks';
import { useTheme } from '@24i/nxg-sdk-higgs';

import SectionHeader from './SectionHeader';
import getSectionWrapperStyles from './styles';
import type { SectionWrapperProps } from './types';

const SectionWrapper: React.FC<SectionWrapperProps> = ({
    title,
    spacing,
    titleConfig = { show: true, align: 'left' },
    onSeeAll,
    children,
    testID,
    styles: getStyles = getSectionWrapperStyles,
    useDefaultPadding,
}) => {
    const { theme } = useTheme();
    const styles = getStyles(theme, spacing, useDefaultPadding);
    const shouldShowTitle = Boolean(titleConfig.show !== false && title);
    return (
        <View style={styles.container} testID={testID}>
            {shouldShowTitle && (
                <SectionHeader
                    title={title}
                    onSeeAll={onSeeAll}
                    styles={styles}
                    testID={testID ? `${testID}.header` : undefined}
                />
            )}
            <View style={styles.content}>{children}</View>
        </View>
    );
};

export default SectionWrapper;
